export default __webpack_public_path__ + "static/ballerina-xs-341aa0791442f5e27302e2a0b68bb698.webp";